import { MenuItem, Select } from "@mui/material";
import React from "react";
import FilterByMonthYear from "../../Filters/FilterByMonthYear";
import OfferTableRow from "../TableRows/OfferTableRow";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

function OfferTable() {
  const [status, setStatus] = React.useState("showAll");

  const handleChange = (event) => {
    setStatus(event.target.value);
  };
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      // border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: ["inter"].join(","),
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    },
  }));
  return (
    <div>
      <div className="flex justify-end gap-4 flex-col md:flex-row bg-white p-4">
        <FilterByMonthYear />

        <div className="flex gap-4 items-center ">
          <p className="text-[#98A2B3] font-['inter'] font-[500] text-[12px]">
            Status:
          </p>
          <Select
            value={status}
            onChange={handleChange}
            className=" font-[400]  bg-[#FFF] w-[190px] h-[48px] "
            sx={{
              border: "1px solid #DEDEDE",
              borderRadius: "4px",
              "&:focus": {
                outline: "none",
              },
            }}
            input={<BootstrapInput />}
          >
            <MenuItem value={"showAll"}>Show All</MenuItem>
            <MenuItem value={"completed"}>Completed</MenuItem>
            <MenuItem value={"pending"}>Pending</MenuItem>
            <MenuItem value={"failed"}>Failed</MenuItem>
            <MenuItem value={"approval"}>For approval</MenuItem>
          </Select>
        </div>
      </div>
      <div className="">
        <OfferTableRow />
      </div>
    </div>
  );
}

export default OfferTable;
